/** True when `path` is the folder itself or sits anywhere under it. */
export const isInsideFolder = (path: string | null, folderPath: string): boolean =>
  path === folderPath || Boolean(path?.startsWith(`${folderPath}/`))
